import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "components/Grid";
import useMediaQuery from "hooks/useMediaQuery";
import { BreakPoints } from "utils/BreakPoints";

// TODO: Make link an array of links
interface Props {
  hideSeals?: boolean;
  background?: string;
  legitScript?: string;
  copyright?: string;
  termsAndConditionsLink?: string;
  privacyPolicyLink?: string;
}

interface isMobile {
  readonly isMobile: boolean;
}

const lsUrl = window.location.protocol + "//static.legitscript.com";

const FooterLinks = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    display: inline-flex;
    margin-left: 16px;
    a {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 140%;
      letter-spacing: -0.01em;
      color: #ffffff;
      opacity: 0.5;
    }
  }
  @media (max-width: 768px) {
    li {
      margin-right: 16px;
    }
  }
`;

const StyledFooter = styled.div<Props>`
  display: flex;
  padding: 30px 0;
  background-color: ${(props) =>
    props.background ? props.background : "transparent"};
  p {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 140%;
    letter-spacing: -0.01em;
    color: #ffffff;
    opacity: 0.5;
  }
  // @media (min-width: 992px) {
  //   margin-bottom: 65px;
  // }
  // @media (max-width: 991px) {
  //   margin-bottom: 80px;
  // }
  @media (max-width: 768px) {
    // max-height: 142px;
    padding: 30px 15px 30px 15px;

    p {
      margin-left: 20%;
      margin-bottom: 30px;
    }
  }
`;

const MobileView = styled.div<isMobile>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const LogosView = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  list-style: none;
  padding: 25px 0;
  margin: 0;
  @media (max-width: 768px) {
    flex-direction: column;
  }
  li {
    display: flex;
    padding-right: 25px;
    @media (max-width: 768px) {
      padding: 10px 0;
    }
  }
`;

const Footer: React.FC<Props> = ({
  background,
  legitScript,
  copyright,
  termsAndConditionsLink,
  privacyPolicyLink,
  hideSeals,
}) => {
  const isMobile = useMediaQuery(BreakPoints.MOBILE);
  return (
    <StyledFooter background={background}>
      <Container>
        {isMobile ? (
          <MobileView isMobile={isMobile}>
            <p style={{ marginLeft: "0%" }}>{copyright}</p>
            <FooterLinks>
              {/* Create a ENV Value for the baseUrl OR Global Variable */}
              <li>
                <a href={termsAndConditionsLink}>Terms and Conditions</a>
              </li>
              <li>
                <a href={privacyPolicyLink}>Privacy Policy</a>
              </li>
            </FooterLinks>
          </MobileView>
        ) : (
          <Row>
            <Col size={1}>
              <p>{copyright}</p>
            </Col>
            <Col align="end" size={1}>
              <FooterLinks>
                {/* Create a ENV Value for the baseUrl OR Global Variable */}
                <li>
                  <a href={termsAndConditionsLink}>Terms and Conditions</a>
                </li>
                <li>
                  <a href={privacyPolicyLink}>Privacy Policy</a>
                </li>
              </FooterLinks>
            </Col>
          </Row>
        )}
        {!hideSeals && (
          <Row>
            <Col size={12}>
              <LogosView>
                <li>
                  <img
                    width="65px"
                    src="https://d1emuhkjqfrsse.cloudfront.net/images/5dc4def63441075e1e68a30c_joint-commission.webp"
                    alt="Joint Commison"
                  />
                </li>
                <li>
                  <img
                    width="150px"
                    src="https://cdn.zinniahealth.com/wp-content/uploads/20220622094645/dhcs-logo-white.webp"
                    alt="A"
                  />
                </li>
                <li>
                  <img
                    width="100px"
                    src={`${lsUrl}/seals/${legitScript}.png`}
                    alt={"LegitScript approved"}
                  />
                </li>
              </LogosView>
            </Col>
          </Row>
        )}
      </Container>
    </StyledFooter>
  );
};

export default Footer;
